<template>
<footer class="footer">
  <div class="content has-text-centered">
    <p>
      &copy; The University of Texas at Austin 2019
    </p>
    <img src="../img/ican.png" alt="Texas I-CAN! at The Unviersity of Texas at Austin" />
  </div>
</footer>
</template>

<script>
export default {
}
</script>

<style lang='scss'>
.footer{
  margin-top:40px;
}
</style>